import React, { Component } from 'react'
import {
  Badge, Row, Col, Card, CardHeader, 
  CardFooter, CardBody, Label, Input, Button,
  Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"
import classnames from 'classnames'
import TextEditor2 from '../TextEditor/TextEditor2'
import AnswerChoiceEditor from './AnswerChoiceEditor'
import NodeTagger from './CreateManageContent/NodeTagger'
import ItemInfo from './CreateManageContent/ItemInfo'
import { InlineMath, BlockMath } from 'react-katex'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'

class CreateContent extends Component {
  constructor(props) {
    super(props)

    this.state = {
      text: ''
    }

  }



  render() {
    const modules = {
      formula: true,
      toolbar: [
        [{ 'header': '1'}, {'header': '2'}, { 'font': [] }],
        [{size: []}],
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [{'list': 'ordered'}, {'list': 'bullet'}, 
         {'indent': '-1'}, {'indent': '+1'}],
        ['link', 'image', 'video'],
        ['clean'],
        ['formula']
      ]
    }


    let colorScheme
    const colors = {
      Course: 'warning',
      Lesson: 'success',
      Set: 'info',
      Item: 'primary',
    }
    this.props.contentType
    ? colorScheme = colors[this.props.contentType]
    : colorScheme = 'primary' 
    
    const answerCards = this.props.answers.map( (answer, n) => {
      return ( 
        <Row key={'answerChoiceEditorCard' + n}>
          <Col xs='12' sm='12' md='12' lg='12'>
            <AnswerChoiceEditor 
              colorScheme={colorScheme}
              correctChoiceQ={answer.correct}
              cardIndex={n}
              activeEdit={this.props.activeEdit}
              onEditorStateChange={this.props.onEditorStateChange}
              editorState={this.props.editorState}
              answers={this.props.answers}
              toggleActiveEditor={this.props.toggleActiveEditor}
              handleDeleteAnswerChoice={this.props.handleDeleteAnswerChoice}
              handleClickThumb={this.props.handleClickThumb}
              shuffle={this.props.shuffle}
              startingLetter={this.props.startingLetter}
              quillText={this.props.quillText}
              handleQuillChange={this.props.handleQuillChange}
            />
          </Col>
        </Row>
      )
    })

    let saveButton
    if (this.props.noChanges) {
      saveButton = <Button color='primary mr-3' disabled>Saved</Button>
    } else if (this.props.isSaving) {
      saveButton = <Button color='primary mr-3'><i className="fa fa-circle-o-notch fa-lg fa-spin mr-1 ml-1"></i></Button>
    } else {
      saveButton = <Button color='primary mr-3' onClick={(e) => this.props.handleClickSave(e)}>Save</Button>
    }

    const warnModal = ( 
      <Modal isOpen={this.props.modalOpen} toggle={this.props.closeTheModal}
        className={'modal-primary'}>
        <ModalHeader toggle={this.togglePrimary}>Unsaved Changes</ModalHeader>
        <ModalBody>
          There are some unsaved changes to your item. Do you want to CONTINUE to create a new item
          and discard those changes, or CANCEL?
        </ModalBody>
        <ModalFooter>
          <Button color="primary" name={'Continue'} onClick={(e) => this.props.handleNewItemWarnClick(e)}>Continue</Button>{' '}
          <Button color="secondary" name={'Cancel'} onClick={(e) => this.props.handleNewItemWarnClick(e)}>Cancel</Button>
        </ModalFooter>
      </Modal>
    )

    let nodeTagger = null
    if (this.props.nodes) {
      nodeTagger = (
        <NodeTagger 
          nodes={this.props.nodes} 
          nodeTags={this.props.nodeTags} 
          addNodeTag={this.props.addNodeTag} 
          deleteNodeTag={this.props.deleteNodeTag} 
        />
      )
    }



    
    return (
      <div className='animated fadeIn'>
        {warnModal}
        <Row>
          <Col xs='12' sm='12' md='12'>
            
            <Card className={'card-accent-' + colorScheme}>
              <CardHeader>
                <i className="icon-settings icons font-1xl mt-2"></i>Content Settings                           
              </CardHeader>
              <CardBody className='card-body'>

                <Row>
                <Col xs='12'>
                  <Button 
                    color={this.props.contentType === 'Item' ? 'primary' : 'secondary'}
                    onClick={() => this.props.toggleContentType('Item') }                      
                  >
                    Item
                  </Button>
                  <Button 
                    color={this.props.contentType === 'Set' ? 'info' : 'secondary'}
                    onClick={() => this.props.toggleContentType('Set')}
                  >
                    Set
                  </Button>
                  <Button 
                    color={this.props.contentType === 'Lesson' ? 'success' : 'secondary'}
                    onClick={() => this.props.toggleContentType('Lesson')}                    
                  >
                    Lesson
                  </Button>
                  <Button 
                    color={this.props.contentType === 'Course' ? 'warning' : 'secondary'}
                    onClick={() => this.props.toggleContentType('Course')}  
                  >
                    Course
                  </Button>  
                </Col>
                <Col xs='12' className='mt-2'>
                  <Input type='select' onChange={this.props.toggleItemType} value={this.props.itemType} >
                    <option>Multiple Choice</option>
                    <option>True/False</option>
                  </Input>
                </Col>
                <Col xs='12' className='mt-2'>
                  <Label className={"switch switch-3d mr-2 switch-" + colorScheme}>
                    <Input 
                      type="checkbox" 
                      className="switch-input" 
                      value={this.props.shuffle ? 'on' : 'off'}
                      checked={this.props.shuffle}
                      onChange={this.props.toggleShuffle}  
                    />
                    <span className="switch-label"></span>
                    <span className="switch-handle"></span>
                  </Label>
                  {this.props.shuffle ? 'Shuffle On' : 'Shuffle Off'}                  
                </Col>
                <Col xs='12' lg='12'>
                  <Label className={'switch switch-3d mr-2 switch-' + colorScheme}>
                  <Input 
                    type='checkbox'
                    className='switch-input'
                    value={this.props.startingLetter === 'f' ? 'off' : 'on'}
                    checked={this.props.startingLetter === 'f'}
                    disabled={this.props.shuffle}
                    onChange={() => this.props.setStartingLetter(this.props.startingLetter === 'a' ? 'f' : 'a')}
                  />
                  <span className='switch-label'></span>
                  <span className='switch-handle'></span>
                  </Label>
                  {this.props.startingLetter === 'a' ? 'ABCDE' : this.props.startingLetter === 'f' ? 'FGHJK' : ''}
                </Col>
                <Col xs='12' lg='12'>
                  <ItemInfo 
                    handleInfoChange={this.props.handleInfoChange} 
                    itemName={this.props.itemName} 
                    itemCode={this.props.itemCode} 
                  />
                </Col>

                </Row>
              </CardBody>
            </Card>   
          </Col>
        </Row>
        <Row>
          {nodeTagger}
        </Row>
          
        <Row>
          <Col>
            <Card className={'card-accent-' + colorScheme}>
              <CardHeader>
                <i className="icon-note icons font-1xl mt-2"></i>Question                 
              </CardHeader>
              <CardBody className='card-body'>
                {this.props.activeEdit.type === 'question'
                  ? <TextEditor2
                      editorId={{type: 'question'}} 
                      editorState={this.props.editorState}
                      handleEditorStateChange={this.props.onEditorStateChange}
                      quillText={this.props.quillText}
                      handleQuillChange={this.props.handleQuillChange}
                    />
                  : <div
                      dangerouslySetInnerHTML={{__html: this.props.question}} 
                      onClick={(e) => this.props.toggleActiveEditor(e, {type: 'question', index: 0})} />
                }
              </CardBody>
            </Card>
          </Col>
        </Row>
          {answerCards}
          <Col>
            <Card>
            <CardHeader>
              Math Experiment
            </CardHeader>
            <CardBody>
              <ReactQuill 
                value={this.state.text} 
                onChange={this.handleQuillChange} 
                theme='snow'
                modules={modules}
                placeholder={'Write something...'}
              />
            </CardBody>
            </Card>
          </Col>   
        <Row>
          <Col>
            <Button color='secondary' onClick={this.props.handleAddAnswerChoice}>+ Add Choice</Button>
          </Col>
          <Col>
            {saveButton}
            <Button color='success' onClick={() => this.props.handleNewItemClick()}>New Item</Button>
          </Col>
        </Row>          
      </div>
    )
  }
}

export default CreateContent

// Create a new item, set, lesson, or course 
// Select type of question from dropdown
// Incorporate DraftJS or Quill
// Add a text question with answer choices
// Create a basic data structure

/*

<Row>
          <Col xs='12' sm='12' md='12' lg='6'>
            <AnswerChoiceEditor 
              colorScheme={colorScheme}
              correctChoiceQ={true}
              cardIndex={0}
              activeEdit={this.props.activeEdit}
              onEditorStateChange={this.props.onEditorStateChange}
              editorState={this.props.editorState}
              answers={this.props.answers}
              toggleActiveEditor={this.props.toggleActiveEditor}
            />

              </Col>
              <Col xs='12' sm='12' md='12' lg='6'>
                <Card className={'card-accent-' + colorScheme}>
                  <CardHeader>
                    <i className="icon-dislike icons font-1xl mt-2"></i>Incorrect Choice                 
                  </CardHeader>
                  <CardBody className='card-body'>
                    Add an incorrect choice here.
                  </CardBody>
                  <CardHeader>
                    <i className="icon-speech icons font-1xl mt-2"></i>Feedback                 
                  </CardHeader>
                  <CardBody className='card-body'>
                    Explain why this is wrong.
                  </CardBody>
                </Card>
              </Col>
              <Col xs='12' sm='12' md='12' lg='6'>
                <Card className={'card-accent-' + colorScheme}>
                  <CardHeader>
                    <i className="icon-dislike icons font-1xl mt-2"></i>Incorrect Choice                 
                  </CardHeader>
                  <CardBody className='card-body'>
                    Add an incorrect choice here.
                  </CardBody>
                </Card>
              </Col>
              <Col xs='12' sm='12' md='12' lg='6'>
                <AnswerChoiceEditor 
                  colorScheme={colorScheme}
                  correctChoiceQ={true}
                  cardIndex={3}
                  activeEdit={this.props.activeEdit}
                  onEditorStateChange={this.props.onEditorStateChange}
                  editorState={this.props.editorState}
                  answers={this.props.answers}
                  toggleActiveEditor={this.props.toggleActiveEditor}
                />
              </Col>
            </Row>



*/


// WEBPACK FOOTER //
// ./src/components/Content/CreateContent.js